<app-ui-page-shell
  [menuSections]="menuSections"
  [activePath]="activePath"
  [sidebarCollapsed]="sidebarCollapsed"
  [title]="title"
  [breadcrumbs]="breadcrumbs"
  appName="SupplySync"
  [user]="user"
  (sidebarToggle)="onSidebarToggle($event)"
  (navigate)="onNavigate($event)"
  (logout)="onLogout()">

  <!-- Stat Cards -->
  <div class="ui-showcase__stats">
    <app-ui-stat-card label="Total Requisitions" [value]="statCards.total" icon="description" variant="default"></app-ui-stat-card>
    <app-ui-stat-card label="Approved" [value]="statCards.approved" icon="check_circle" variant="success"></app-ui-stat-card>
    <app-ui-stat-card label="Pending" [value]="statCards.pending" icon="schedule" variant="warning"></app-ui-stat-card>
    <app-ui-stat-card label="Rejected" [value]="statCards.rejected" icon="cancel" variant="danger"></app-ui-stat-card>
  </div>

  <!-- Data Table Card -->
  <div class="ui-showcase__table-card">
    <app-ui-table-toolbar
      title="List of Purchase Requisitions"
      [subtitle]="tableSubtitle"
      searchPlaceholder="Search req no, branch, section.."
      [searchValue]="searchTerm"
      [filters]="filters"
      (search)="onSearch($event)"
      (filterChange)="onFilterChange($event)"
      (export)="onExport()"
      (create)="onCreate()">
    </app-ui-table-toolbar>

    <app-ui-data-table
      [columns]="columns"
      [rows]="tableRows"
      [sortColumn]="sortColumn"
      [sortDirection]="sortDirection"
      (sort)="onSort($event)"
      (linkClick)="onLinkClick($event)"
      (actionClick)="onActionClick($event)">
    </app-ui-data-table>

    <app-ui-pagination
      [currentPage]="currentPage"
      [totalPages]="totalPages">
    </app-ui-pagination>
  </div>

</app-ui-page-shell>
